<template>
  <div class="card">
    <div
      v-if="this.errosValidacaoGeral.length"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            <ul>
              <li v-for="value in this.errosValidacaoGeral" :key="value">
                {{ value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="card-header">
      <h3 class="card-title">
        <img
          src="media/icons/duotune/general/gen002.svg"
          class="me-2"
        />Atualizações de Plano
      </h3>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharAtualizacaoPlano', false)"
      >
        <span class="svg-icon svg-icon-2x">
          <img src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisar"
              type="text"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar"
            />
          </div>
        </div>
        <div class="card-toolbar">
          <div
            v-if="checked.length === 0"
            class="d-flex justify-content-end"
            data-kt-customer-table-toolbar="base"
          >
            <button
              v-if="this.modal === false"
              @click="this.$refs.table.exportarExcel()"
              type="button"
              class="btn btn-sm btn-light-primary me-3"
            >
              <span class="svg-icon svg-icon-2">
                <inline-svg src="media/icons/duotune/arrows/arr078.svg" />
              </span>
              Exportar
            </button>
          </div>
          <div
            v-else
            class="d-flex justify-content-end align-items-center"
            data-kt-customer-table-toolbar="selected"
          >
            <div class="fw-bolder me-5">
              <span class="me-2">{{ checked.length }}</span
              >Selecionado(s)
            </div>
            <button
              v-if="this.modal === false"
              type="button"
              class="btn btn-sm btn-danger"
              @click="cancelarSelecionados()"
            >
              Cancelar Selecionado(s)
            </button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhuma solicitação encontrada"
          @checked-rows="checked = $event"
          :colors="false"
        >
          <template v-slot:cell-checkbox="{ row: data }">
            <div
              class="form-check form-check-sm form-check-custom form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="data.id"
                v-model="checked"
              />
            </div>
          </template>
          <template v-slot:cell-id="{ row: data }">
            {{ data.id }}
          </template>
          <template v-slot:cell-tipo="{ row: data }">
            <span
              v-if="data.finalizado === '1'"
              class="badge badge-square badge-danger d-flex p-2"
              >{{ "Finalizado" }}</span
            >
            <span
              v-else-if="data.cancelado === '1'"
              class="badge badge-square badge-secondary d-flex p-2"
              >{{ "Cancelado" }}</span
            >
            <span
              v-else-if="data.tipo_pacote_atual === 0"
              class="badge badge-square badge-success d-flex p-2"
              >{{ "Cliente Novo" }}</span
            >
            <span v-else class="badge badge-square badge-primary d-flex p-2">{{
              "Atualização"
            }}</span>
          </template>
          <template v-slot:cell-RevendaNome="{ row: data }">
            {{
              data.Revenda ? data.Revenda.id + " - " + data.Revenda.nome : ""
            }}
            <span v-if="data.Revenda" class="text-muted fw-bold d-block fs-8">
              {{
                data.Revenda.fantasia +
                " - " +
                this.$utils.setMask(
                  data.Revenda.cnpj,
                  "##.###.###/####-##",
                  true
                )
              }}
            </span>
          </template>
          <template v-slot:cell-EmitenteNome="{ row: data }">
            {{
              data.Emitente ? data.Emitente.id + " - " + data.Emitente.nome : ""
            }}
            <span v-if="data.Emitente" class="text-muted fw-bold d-block fs-8">
              {{
                data.Emitente.fantasia +
                " - " +
                this.$utils.setMask(
                  data.Emitente.cnpj,
                  "##.###.###/####-##",
                  true
                )
              }}
            </span>
          </template>
          <template v-slot:cell-contato="{ row: data }">
            <button
              class="btn btn-sm btn-light-primary"
              @click="this.contatoEmitente(data.Emitente)"
            >
              Contato
            </button>
          </template>
          <template v-slot:cell-EmitenteCidade="{ row: data }">
            {{
              data.Emitente ? data.Emitente.cidade + "/" + data.Emitente.uf : ""
            }}
          </template>
          <template v-slot:cell-tipo_pacote_atual="{ row: data }">
            <span
              class="badge badge-square text-gray-800 badge-light-info d-flex p-2"
              >{{ this.retornarTipoPacote(data.tipo_pacote_atual) }}</span
            >
          </template>
          <template v-slot:cell-tipo_pacote_solicitado="{ row: data }">
            <span
              class="badge badge-square text-gray-800 badge-light-success d-flex p-2"
              >{{ this.retornarTipoPacote(data.tipo_pacote_solicitado) }}</span
            >
          </template>
          <template v-slot:cell-UsuarioNome="{ row: data }">
            <div class="min-w-100px">
              {{ data.Usuario ? data.Usuario.nome : "" }}
            </div>
          </template>
          <template v-slot:cell-createdAt="{ row: data }">
            {{ this.$utils.formatarDataHoraFusoHorario(data.createdAt) }}
          </template>
          <template v-slot:cell-acoes="{ row: data }">
            <div v-if="data.finalizado === '0' && data.cancelado === '0'">
              <button
                v-if="this.modal === false"
                class="btn btn-sm btn-light btn-active-light-primary ms-2"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
              >
                Ações
                <span class="svg-icon svg-icon-5 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <div
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                data-kt-menu="true"
              >
                <div class="menu-item px-3">
                  <a @click="confirmarRegistro(data)" class="menu-link px-3"
                    >Confirmar</a
                  >
                </div>
                <div class="menu-item px-3">
                  <a @click="cancelarRegistro(data.id)" class="menu-link px-3"
                    >Cancelar</a
                  >
                </div>
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <div v-if="exibirModalContatoEmitente" class="modal-overlay">
    <div
      ref="kt_modal_emitente_contato"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_emitente_contato"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title d-flex align-items-center">
              <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                <inline-svg
                  src="media/icons/duotune/communication/com005.svg"
                />
              </span>
              <h3 class="fw-bold m-0 text-gray-800">Contato</h3>
            </div>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="modalContatoEmitente(false)"
            >
              <span class="svg-icon svg-icon-1 svg-icon lh-0">
                <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body">
            <table
              class="table align-middle table-row-dashed fs-6 text-gray-600 fw-bold gy-5 table-hover"
            >
              <tbody>
                <tr>
                  <td class="ps-5">
                    {{ "Nome: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.emitente.nome }}
                  </td>
                </tr>
                <tr>
                  <td class="ps-5">
                    {{ "Responsável: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.emitente.responsavel }}
                  </td>
                </tr>
                <tr>
                  <td class="ps-5">
                    {{ "Telefone: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.emitente.telefone }}
                  </td>
                </tr>
                <tr v-if="this.emitente.fax">
                  <td class="ps-5">
                    {{ "Celular: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.emitente.fax }}
                  </td>
                </tr>
                <tr>
                  <td class="ps-5">
                    {{ "Email: " }}
                  </td>
                  <td class="min-w-250px">
                    {{ this.emitente.email }}
                  </td>
                </tr>
                <tr v-if="this.emitente.site">
                  <td class="ps-5">
                    {{ "Site: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.emitente.site }}
                  </td>
                </tr>
                <tr>
                  <td class="ps-5">
                    {{ "Endereço: " }}
                  </td>
                  <td>
                    <div class="min-w-250px align-middle">
                      <div>
                        <span class="text-dark text-hover-primary mb-1">
                          {{
                            this.emitente.endereco +
                            ", " +
                            this.emitente.numero +
                            " - " +
                            this.emitente.bairro +
                            " - " +
                            this.emitente.cidade +
                            " - " +
                            this.emitente.uf
                          }}
                        </span>
                        <span class="text-muted fw-bold d-block">
                          {{
                            this.emitente.complemento
                              ? this.emitente.complemento + " "
                              : ""
                          }}
                          {{ "CEP: " + this.emitente.cep }}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <EmitentePacoteModal
    ref="emitentePacoteModal"
    v-if="exibirModalPacoteEmitente"
    :emitentePacote="this.atualizacaoPlano.Emitente"
    :modal="true"
    :isRevenda="this.isRevenda"
    :errosValidacao="this.errosValidacao"
    @exibirModalEmitentePacote="modalPacoteEmitente"
    @confirmarEmitentePacote="confirmarAtualizacaoPlano"
  ></EmitentePacoteModal>
  <LoadingModal
    :nomeRef="'loadingModalUpgradePlan'"
    mensagem=""
    v-if="this.loading === true"
  ></LoadingModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import EmitentePacoteModal from "../empresas/EmitentePacoteModal.vue";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { hideModalId, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { useToast } from "vue-toastification";
const toast = useToast();

const atualizacaoPlanoInicializada = {
  id: 0,
  id_empresa: 0,
  id_revenda: 0,
  tipo_pacote_solicitado: 0,
  qtd_pdv_solicitado: 0,
  qtd_terminais_solicitado: 0,
  valor_contrato_solicitado: 0,
  Emitente: {
    tipo_pacote: 0,
    qtd_pdv: 0,
    qtd_terminais: 0,
    valor_contrato: 0,
  },
};

export default {
  emits: ["fecharAtualizacaoPlano"],
  components: {
    Datatable,
    EmitentePacoteModal,
    LoadingModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loading = true;
        getOrCreateInstanceModal(
          "loadingModalUpgradePlan",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalUpgradePlan", () => {
          this.loading = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    modalPacoteEmitente(exibir) {
      this.exibirModalPacoteEmitente = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_emitente_pacote",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_emitente_pacote");
          },
          /*close*/ () => {
            this.modalPacoteEmitente(false);
          }
        );
      }
    },
    async contatoEmitente(empresa) {
      this.emitente = null;
      try {
        var ret = await this.$store.dispatch(
          "emitente/getEmitente",
          empresa.id
        );
        if (ret.Success === true) {
          this.emitente = ret.Data;
          this.modalContatoEmitente(true);
        }
      } catch (error) {
        console.log(error);
      }
    },
    modalContatoEmitente(exibir) {
      this.exibirModalContatoEmitente = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_emitente_contato",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_emitente_contato");
          },
          /*close*/ () => {
            this.modalContatoEmitente(false);
          }
        );
      }
    },
    retornarTipoPacote(pacote) {
      const pacoteMap = {
        0: "Emissor Gratuíto",
        1: "Emissor",
        2: "Gestor",
        3: "Indústria",
      };

      return pacoteMap[pacote] || "Pacote não definido";
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(Emitente/nome, '" +
          pesquisa +
          "') or contains(Emitente/fantasia, '" +
          pesquisa +
          "') or contains(Emitente/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(Revenda/nome, '" +
          pesquisa +
          "') or contains(Revenda/fantasia, '" +
          pesquisa +
          "') or contains(Revenda/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(Emitente/cidade, '" +
          pesquisa +
          "') or contains(Emitente/uf, '" +
          pesquisa +
          "') or contains(Usuario/nome, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async cancelarSelecionados() {
      await this.$swal.showQuestionAlert(
        "Deseja cancelar as solicitações selecionadas?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            for (var i = 0; i < this.checked.length; i++) {
              await this.excluirAtualizacaoPlano(this.checked[i]);
            }
            if (this.excluiuCadastro === true) {
              toast.success("Solicitações canceladas com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async cancelarRegistro(id) {
      await this.$swal.showQuestionAlert(
        "Deseja cancelar a solicitação?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            await this.excluirAtualizacaoPlano(id);
            if (this.excluiuCadastro === true) {
              toast.success("Solicitação cancelada com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async excluirAtualizacaoPlano(id) {
      try {
        await this.$store.dispatch(
          "atualizacaoPlano/postAtualizacaoPlanoCancelarPlano",
          id
        );
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    async confirmarRegistro(data) {
      this.atualizacaoPlano = JSON.parse(
        JSON.stringify(atualizacaoPlanoInicializada)
      );

      this.atualizacaoPlano.id = data.id;
      this.atualizacaoPlano.id_empresa = data.Emitente.id;
      this.atualizacaoPlano.id_revenda = data.Revenda.id;
      this.atualizacaoPlano.Emitente.tipo_pacote = data.tipo_pacote_solicitado;

      if (data.Revenda.cnpj === "00221619000126") {
        try {
          let ret = await this.$store.dispatch(
            "atualizacaoPlano/getAtualizacaoPlano",
            data.id
          );
          if (ret.Success === true) {
            this.atualizacaoPlano.Emitente.qtd_pdv =
              ret.Data.qtd_pdv_solicitado;
            this.atualizacaoPlano.Emitente.qtd_terminais =
              ret.Data.qtd_terminais_solicitado;
            this.atualizacaoPlano.Emitente.valor_contrato =
              ret.Data.valor_contrato_solicitado;
            this.isRevenda = false;
            this.modalPacoteEmitente(true);
            setTimeout(() => {
              this.$refs.emitentePacoteModal.calcularValorPacote();
            }, 500);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          let ret = await this.$store.dispatch(
            "emitente/getEmitente",
            data.Emitente.id
          );
          if (ret.Success === true) {
            this.atualizacaoPlano.Emitente.qtd_pdv = ret.Data.qtd_pdv;
            this.atualizacaoPlano.Emitente.qtd_terminais =
              ret.Data.qtd_terminais;
            this.atualizacaoPlano.Emitente.valor_contrato =
              ret.Data.valor_contrato;
            this.isRevenda = true;
            this.modalPacoteEmitente(true);
            setTimeout(() => {
              this.$refs.emitentePacoteModal.calcularValorPacote();
            }, 500);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async confirmarAtualizacaoPlano(emitentePacote) {
      this.errosValidacaoGeral = [];
      this.errosValidacao = {};

      this.atualizacaoPlano.tipo_pacote_solicitado = emitentePacote.tipo_pacote;
      this.atualizacaoPlano.qtd_pdv_solicitado = emitentePacote.qtd_pdv;
      this.atualizacaoPlano.qtd_terminais_solicitado =
        emitentePacote.qtd_terminais;
      this.atualizacaoPlano.valor_contrato_solicitado =
        emitentePacote.valor_contrato;
      this.atualizacaoPlano.Emitente = null;

      await this.exibirModalLoading(true);

      try {
        var ret = await this.$store.dispatch(
          "atualizacaoPlano/postAtualizacaoPlanoConfirmarPlano",
          this.atualizacaoPlano
        );
        if (ret.Success === true) {
          toast.success("Solicitação finalizada com sucesso!", {
            timeout: 3000,
          });
          hideModalId("kt_modal_emitente_pacote");
          this.modalPacoteEmitente(false);
        }
      } catch (error) {
        console.log(error);
        this.errosValidacao = error;
        this.errosValidacaoGeral.push(error.Message);
      }
      await this.exibirModalLoading(false);
      this.$refs.table.load();
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  async mounted() {
    setTimeout(() => {
      this.nextFocus("txtPesquisar");
    }, 800);
  },
  data() {
    return {
      isRevenda: true,
      loading: false,
      atualizacaoPlano: JSON.parse(
        JSON.stringify(atualizacaoPlanoInicializada)
      ),
      exibirModalPacoteEmitente: false,
      emitente: null,
      exibirModalContatoEmitente: false,
      checked: [],
      errosValidacaoGeral: [],
      errosValidacao: {},
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Tipo",
          key: "tipo",
          sortable: false,
        },
        {
          name: "Revenda",
          key: "RevendaNome",
          sortingField: "Revenda/nome",
          sortable: true,
        },
        {
          name: "Cliente",
          key: "EmitenteNome",
          sortingField: "Emitente/nome",
          sortable: true,
        },
        {
          name: "Contato",
          key: "contato",
          sortable: false,
        },
        {
          name: "Cidade/UF",
          key: "EmitenteCidade",
          sortingField: "Emitente/cidade",
          sortable: true,
        },
        {
          name: "Pacote Atual",
          key: "tipo_pacote_atual",
          sortable: true,
        },
        {
          name: "Pacote Solicitado",
          key: "tipo_pacote_solicitado",
          sortable: true,
        },
        {
          name: "Solicitado por",
          key: "UsuarioNome",
          sortingField: "Usuario/nome",
          sortable: true,
        },
        {
          name: "Data",
          key: "createdAt",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "atualizacaoPlano/getAtualizacaoPlanoOData",
        selectOData:
          "?$select=id,tipo_pacote_atual,tipo_pacote_solicitado,createdAt,finalizado,cancelado&$expand=Emitente($select=id,nome,fantasia,cnpj,uf,cidade),Usuario($select=nome),Revenda($select=id,nome,fantasia,cnpj)",
        filterOData: "",
        search: "",
        defaultSort: "cancelado, finalizado, createdAt asc",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
